import { useState } from 'react';
import Modal from './Modal';
import RaceSelection from '../RaceSelection';
import { RaceData } from './RaceModal';
import { Button } from '../ui/button';

interface AttachRaceModalProps {
  show: boolean;
  onClose: () => void;
  onSubmit: (surveyId: number, raceId: number) => Promise<void>;
  onRaceAdd: (race: RaceData) => Promise<void>;
  races: RaceData[];
  survey: {
    id: number;
    name: string;
    email: string;
    race?: RaceData;
  };
}

export default function AttachRaceModal({
  show,
  onClose,
  onSubmit,
  onRaceAdd,
  races,
  survey,
}: AttachRaceModalProps) {
  const [selectedRace, setSelectedRace] = useState<RaceData | null>(
    survey.race || null,
  );
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedRace?.id) {
      window.dispatchEvent(new CustomEvent('showToast', { detail: { message: 'Please select a race.', type: 'error' } }));
      return;
    }

    setIsSubmitting(true);
    try {
      await onSubmit(survey.id, selectedRace.id);
      onClose();
    } catch (error) {
      console.error('Failed to attach race:', error);
      window.dispatchEvent(new CustomEvent('showToast', { detail: { message: 'Failed to attach race. Please try again.', type: 'error' } }));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={show} onClose={onClose}>
      <form onSubmit={handleSubmit}>
        <div className="space-y-4">
          <div>
            <h2 className="text-lg font-medium text-gray-900">
              Attach Race to Survey
            </h2>
            <p className="text-sm text-gray-600 mt-1">
              Select a race for <strong>{survey.name}</strong> ({survey.email})
            </p>
          </div>

          <RaceSelection
            races={races}
            selectedRace={selectedRace}
            onRaceSelect={setSelectedRace}
            onRaceAdd={onRaceAdd}
          />

          <div className="flex justify-end gap-2 pt-4">
            <Button
              type="button"
              variant="outline"
              onClick={onClose}
              disabled={isSubmitting}
            >
              Cancel
            </Button>
            <Button type="submit" disabled={isSubmitting || !selectedRace}>
              {isSubmitting ? 'Attaching...' : 'Attach Race'}
            </Button>
          </div>
        </div>
      </form>
    </Modal>
  );
}
